var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "footer-main-container bg-light-grey" },
    [
      _c(
        "accordion-group",
        { staticClass: "footer-main" },
        _vm._l(_vm.filteredBlocks, function(block) {
          return _c(
            "div",
            {
              key: block.id,
              staticClass: "footer-main__column",
              class: {
                "footer-main__column--large footer-main__column--logo":
                  block.type === "logo_block"
              }
            },
            [
              block.type === "link_list_block" && _vm.$mq === "mobile"
                ? _c(
                    "accordion",
                    {
                      staticClass: "footer-main__menu-accordion",
                      attrs: {
                        heading: block.settings.menu.title,
                        activeIcon: "minus",
                        inactiveIcon: "plus",
                        iconSize: "16px",
                        theme: "footer-bourdain"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "footer-main__menu-list" },
                        _vm._l(block.settings.menu.links, function(
                          link,
                          index
                        ) {
                          return _c(
                            "v-link",
                            {
                              key: index,
                              staticClass:
                                "footer-main__menu-link footer-main__menu-link link link--primary",
                              attrs: { href: link.url }
                            },
                            [_vm._v(_vm._s(link.title))]
                          )
                        }),
                        1
                      )
                    ]
                  )
                : block.type === "link_list_block"
                ? _c("div", { staticClass: "footer-main__menu-content" }, [
                    _c("h5", { staticClass: "footer-main__menu-title" }, [
                      _vm._v(_vm._s(block.settings.menu.title))
                    ]),
                    _c(
                      "div",
                      { staticClass: "footer-main__menu-list" },
                      _vm._l(block.settings.menu.links, function(link, index) {
                        return _c(
                          "v-link",
                          {
                            key: index,
                            staticClass:
                              "footer-main__menu-link link link--primary",
                            attrs: { href: link.url }
                          },
                          [_vm._v(_vm._s(link.title))]
                        )
                      }),
                      1
                    )
                  ])
                : _c("div", { staticClass: "footer-main__logo-content" }, [
                    _c(
                      "div",
                      { staticClass: "footer-main__logo-content-container" },
                      [
                        block.settings.logo_png || block.settings.logo_svg
                          ? _c("img", {
                              staticClass: "footer-main__logo",
                              attrs: {
                                src: block.settings.logo_svg
                                  ? block.settings.logo_svg
                                  : block.settings.logo_png,
                                alt: block.settings.logo_png_alt
                                  ? block.settings.logo_png_alt
                                  : "",
                                loading: "lazy"
                              }
                            })
                          : _vm._e(),
                        !_vm.schemaContact.settings.hideContact
                          ? _c("footer-contact-social", {
                              attrs: { schema: _vm.schemaContact }
                            })
                          : _vm._e(),
                        _c("h5", { staticClass: "h6 footer-main__title" }, [
                          _vm._v(_vm._s(block.settings.title))
                        ]),
                        _c("div", {
                          staticClass:
                            "footer-main__body body-sm mobile-footer-address",
                          domProps: { innerHTML: _vm._s(block.settings.body) }
                        })
                      ],
                      1
                    )
                  ])
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }